import { render, staticRenderFns } from "./ModalLoading.vue?vue&type=template&id=5a64fe62"
import script from "./ModalLoading.vue?vue&type=script&lang=js"
export * from "./ModalLoading.vue?vue&type=script&lang=js"
import style0 from "./ModalLoading.vue?vue&type=style&index=0&id=5a64fe62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports